import { useContext, useEffect, useMemo } from "react";

import { TourGuideContext } from "common/components/TourGuide_joyride";
import { BsCalendarEvent, BsPower } from "react-icons/bs";
import { IoIosHelp, IoMdTime } from "react-icons/io";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { actionTypes as auth } from "redux/login";
import { LogOutApi } from "redux/logout";
import { EMPTYALLREDUCERS } from "redux/type";
import { useCurrentTime } from "./useCurentTimer";
import { AlertSupply } from "./alertSupply";
const routes = {
  "/HOME": "میزکار",
  "/CHANGE-PASSWORD": "تغییر رمز عبور",
  "/REPORTS": "گزارشات",
  "/OFFLINE-ORDER": "سفارشات آفلاین",
  "/PERIODIC-SAVINGS": "پس انداز دوره ای",
  "/VERIFYPAYMENT": "تأیید درخواست",
  "/PROFILE": "اطلاعات حساب کاربری",
  "/CHILDREN": "صفحه فرزندان",
  "/GOLD": "طلا",
  "/BASKET_MANAGEMENT": "سبد گردانی ",
  "/BASKET_LIST": " تنظیمات سبد گردانی ",
  "/IPO": "عرضه اولیه",
  "/CASH_INTEREST": "سود نقدی",
  "/REQUEST-STATUS": "وضعیت درخواست طلب",
  "/INVITE": "دعوت از دوستان",
  "/STRATEGY": "اجرای استراتژی",
  "/PASSWORD": "دعوت از دوستان",
  "/LOCK": "تغییر رمز عبور",
  "/QUESTION": "پرسشنامه",
  "/LOTTORY": "شرکت در قرعه کشی",
  "/LOTTORYLIST": "نتایج قرعه کشی",
  "/OPTION/WATCH": "دیده‌بان اختیار",
  "/DERIVATIVES": "استراتژی ها باز",
  "/MARKETMAKING": "بازارگردانی",
  "/MARKETMAKING-ALGORITHM": "بازار گردانی الگوریتمی",
  "/PAYMENTS": "درخواست وجه",
  "/TRADES-REQUESTORDER": "معامله تکی",
  "/TRADES-REQUESTORDER-DOUBLE": " معامله ترکیبی",
  "/TECHNICALCHART": "چارت تکنیکال",
  "/CREDIT-STATUS": "وضعیت اعتبار",
  "/CREDIT": "درخواست اعتبار",
  "/BANK-ACCOUNTS": " حساب بانکی",
  "/MARKOWITZCALCULATOR": "ماشین حساب مارکویتز",
  "/OPTIONSTRATEGIES/COVEREDCALL": "کاورد کال(covered call)",
  "/PLEDGESTOCK": "توثیق سهام",
  "/MARKETER/SUBSET": "زیر مجموعه",
  "/MARKETER/PERFORMANCE-EVALUATION": "ارزیابی عملکرد",
  "/MARKETER/FINANCIAL-STATUS": "وضعیت مالی",
  "/MARKETER/CHANGE-SUPERVISOR": "تغییر ناظر",
  "/MARKETER/PROFILE": "شماره حسابها",
  "/MARKETER/PERFORMANCE-REVIEW-CUSTOMERS": "بررسی عملکرد مشتریان",
  "/MARKETER/PERFORMANCE-REVIEW-MARKETER": "بررسی عملکرد بازاریابان",
  "/MARKETER/CONTRACTS": "قرارداد های بازاریاب",
  "/MARKETER/CONTRACTS/:id": "قرارداد های بازاریاب",
  "/CREDIT-GOLD": "اعتبار طلا",
  "/DAILY-CREDIT": "T0 طلایی",
  "/COURSES": "دوره های آموزشی",
  "/COURSES/:id": "اطلاعات دوره",
  "/DEPOSIT": "واریز وجه",
  "/ATIREQUESTFUNDS": "تقاضای وجه بورس کالا و آتی",
  "/ATITRANSFERREQUEST": "انتقال حساب اوراق و کالا",
};

const HeaderLayout = ({ open }) => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const handleExit = () => {
    LogOutApi();
    document.cookie = "admin=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie =
      "is_expired=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

    const adminCookie = document.cookie
      .split("; ")
      .find((row) => row.startsWith("admin="));
    dispatch({ type: EMPTYALLREDUCERS, payload: {} });
    dispatch({ type: auth.logout, payload: {} });
    sessionStorage.removeItem("hjViewportId");
    if (!adminCookie) {
      return history.push("/auth");
    }
  };

  const time = useCurrentTime();
  const runTourGuide = useContext(TourGuideContext).handleClickStartTourGuide;
  const tourGuideSteps = useContext(TourGuideContext).steps;
  const clearSteps = useContext(TourGuideContext).clearSteps;
  useEffect(() => {
    clearSteps();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const getPageTitle = (pathname) => {
    const upperPath = pathname.toUpperCase();

    if (routes[upperPath]) return routes[upperPath];

    const marketerContractsPattern = /^\/MARKETER\/CONTRACTS\/[^/]+$/;
    const courseDetalisPattern = /^\/COURSES\/[^/]+$/;

    if (marketerContractsPattern.test(upperPath)) return "قرارداد های بازاریاب";
    if (courseDetalisPattern.test(upperPath)) return "دوره های آموزشی";

    return "ناشناس";
  };

  const pageTitle = useMemo(
    () => getPageTitle(location.pathname),
    [location.pathname],
  );

  return (
    <div
      className="
        sticky top-0 z-40
        w-full h-[70px]
        bg-[#f5f6fb]
        flex items-center
      "
    >
      <div
        className="
          w-full h-full
          flex items-center justify-between
          px-3 md:px-8
        "
      >
        <div className="text-sm lg:text-lg font-medium text-black md:mr-0 mr-12">
          {pageTitle}
        </div>
        <div className="flex items-center gap-6">
          <AlertSupply />

          {tourGuideSteps.length ? (
            <div
              className={`items-center cursor-pointer flex`}
              onClick={(e) => runTourGuide(e)}
            >
              <IoIosHelp size={30} className="text-gray-400" />
              <span className="hidden md:inline text-sm font-medium mr-1">
                راهنما
              </span>
            </div>
          ) : null}
          <div className="hidden md:flex items-center text-sm">
            <BsCalendarEvent className="ml-1 text-gray-400" />
            <span>
              {new Intl.DateTimeFormat("fa-IR", {
                dateStyle: "full",
                timeStyle: "long",
              })
                .format(new Date())
                .split(" ")[3]
                .split("،")}{" "}
              {new Intl.DateTimeFormat("fa-IR", {
                dateStyle: "full",
                timeStyle: "long",
              })
                .format(new Date())
                .split(" ")[2]
                .split(",")}{" "}
              {
                new Intl.DateTimeFormat("fa-IR", {
                  dateStyle: "full",
                  timeStyle: "long",
                })
                  .format(new Date())
                  .split(" ")[1]
              }{" "}
              {
                new Intl.DateTimeFormat("fa-IR", {
                  dateStyle: "full",
                  timeStyle: "long",
                })
                  .format(new Date())
                  .split(" ")[0]
              }
            </span>
          </div>
          <div className="hidden md:flex items-center text-sm w-[70px]">
            <IoMdTime className="ml-1 text-gray-400 shrink-0" size={20} />
            {time}
          </div>
          <button
            onClick={handleExit}
            className={`
               items-center gap-1
              text-sm font-medium
              hover:text-red-600
              flex
            `}
          >
            <BsPower size={18} />
            <span>خروج</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default HeaderLayout;
